module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Customer Support","routes":{"fraud-cases":"Fraud Cases","messages":"Messages","analysis":"Analysis","whatsapp":"WhatsApp","transactions":"Transactions","analysis-transaction":"Transaction Analysis"}}}')
  delete Component.options._Ctor
}
